/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.attendance.groups-and-marks'},
});

const GroupsAndMarksItem = () => (
  <RouteLinkItem
    route="midas/settings/attendance/groups-and-marks"
    title={messages.title}
  />
);

export default GroupsAndMarksItem;
